import { connect } from 'react-redux'
import Banner      from '../Banner';


const mapStateToProps = (state) => {
    return {
        logo : state.assets.items.logo,
        theme: state.assets.items.theme,
        geo  : state.geo
    }
};

const BannerContainer = connect(mapStateToProps, null)(Banner);

export default BannerContainer;


// WEBPACK FOOTER //
// ./src/components/containers/BannerContainer.js